<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'BlocReassuranceQualiopi'
});
</script>
<template>
  <ka-container
    code="bloc-reassurance-qualiopi"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-image
      code="image"
      :options="{
        animationIn: `fadeIn`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        imgFit: `cover`,
        alt: `La qualité des formations Matchers n'est plus à prouver grâce à la certification Qualiopi`
      }"
      :xs="{ overlay: null }"
      value="https://ucarecdn.com/764dd807-1855-4d97-9071-786f43584501/" />
    <!-- Conteneur -->
    <ka-container code="conteneur">
      <ka-text code="certification">
        <h2 v-html="t('blocReassuranceQualiopi.conteneur.certification.value', `Certification`)" />
      </ka-text>
      <ka-text code="un-service-de-qualite">
        <span v-html="t('blocReassuranceQualiopi.conteneur.unServiceDeQualite.value', `Un service de qualité CERTIFIÉ ! Matchers est LE spécialiste de la formation pratique pour les start-up, TPE et PME 👊`)" />
      </ka-text>
      <!-- Conteneur -->
      <ka-container code="container-1">
        <ka-button
          code="trouver-un-expert"
          :options="{
            ripple: true,
            href: `/experts`,
            ariaLabel: `button`,
            click: componentInstance.trouverUnExpertClick,
            hidden: null
          }"
          :xs="{ hidden: false }">
          <span v-html="t('blocReassuranceQualiopi.conteneur.container1.trouverUnExpert.value', `Trouver un expert`)" />
        </ka-button>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { blocReassuranceQualiopiComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c39')
const component = blocReassuranceQualiopiComponent()
const componentInstance = component.newStoreInstance()
withDefaults(defineProps<{
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

syncComponentStore(componentInstance)
</script>
